import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import { TextInput } from "../../../common/fields";

const AddCustomFieldSectionForm = ({ disabled }) => {
  const intl = useIntl();
  return (
    <div className="flex flex-column gap-4">
      <Section title="identity">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default AddCustomFieldSectionForm;
